import { Component, OnInit } from '@angular/core';
import {VetrinaMeseService} from '../../core/services/tables/vetrina-mese.service';
import {VetrinaMese} from '../../models/VetrinaMese';

@Component({
  selector: 'app-vetrina-mese-page',
  templateUrl: './vetrina-mese-page.component.html',
  styleUrls: ['./vetrina-mese-page.component.scss']
})
export class VetrinaMesePageComponent implements OnInit {

  vetrinaMeseRecords: VetrinaMese[];
  listaSettori: string[] = [];
  arrayToFilter: string[] = [];
  newDate: Date;
  pdfNavigator: number;
  TABLE_SORT_HEADERS: Array<[string, string]> = [
    ['emittente', 'Emittente'],
    ['isin', 'Isin'],
    ['descrizione', 'Descrizione'],
    ['scadenza', 'Scadenza'],
    ['sottostanteBasket', 'Sottostante/Basket']
  ];

  constructor(public service: VetrinaMeseService) {

  }

  ngOnInit(): void {
    this.service.get().then(res => {
      this.pdfNavigator = res.idSum;
      this.vetrinaMeseRecords = res.records;
      res.records.map(el => {
        this.arrayToFilter.push(el.settore);
        this.newDate = new Date(el.dataInserimento);
      });
      this.listaSettori = this.arrayToFilter.filter((el, i) => {
        return this.arrayToFilter.indexOf(el) === i;
      });
    }).catch(err => console.error('Vetrina del mese generated an error: ' + err));
  }
}
